<template>
  <section class="-mt-16 relative z-10 pb-16">
    <div class="max-w-7xl mx-auto px-4 text-center">

      <!-- LOADING -->
      <div v-if="carregando" class="text-center text-gray-500 text-lg py-20">
        Carregando planos...
      </div>

      <!-- CONTEÚDO -->
      <div
        v-else
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 relative z-20"
        :class="gridClasses"
      >
        <div
          v-for="(item, index) in planosAtivos"
          :key="item.id || index"
          class="bg-[#fefefe] rounded-2xl shadow-md p-6 flex flex-col justify-between items-center border-b-4 border-cormenubotaoplanos hover:shadow-lg transition h-full"
        >
          <div class="flex flex-col items-center mb-6">
            <img :src="item.icone" :alt="item.nome" class="h-12 mb-4" />
            <h3 class="text-lg font-bold text-[#1a1a1a] mb-2">{{ item.nome }}</h3>
            <p class="text-sm text-gray-700 leading-relaxed text-center">{{ item.descricao }}</p>
          </div>
          <div class="flex flex-col items-center justify-end min-h-[140px]">
            <p class="italic text-gray-500 mb-1">a partir:</p>
            <div class="flex items-start text-cormenubotaoplanos mb-1">
              <span class="text-sm font-normal relative top-[2px] mr-1">R$</span>
              <span class="text-3xl font-bold">{{ formatarPreco(item.valor) }}</span>
            </div>
            <p class="text-cormenubotaoplanos text-sm mb-3">/mês</p>
            <a
              :href="item.link || '#'"
              class="bg-cormenubotaoplanos text-white text-sm font-semibold px-6 py-2 rounded-full hover:brightness-110 transition"
            >
              + PLANOS
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script setup>
import { ref, onMounted, computed } from 'vue'
import axios from '@/services/api'

const planosAtivos = ref([])
const carregando = ref(true)

const formatarPreco = (valor) => {
  return valor.toFixed(2).replace('.', ',')
}

// Objeto com as classes possíveis, ativadas dinamicamente
const gridClasses = computed(() => {
  const qtd = planosAtivos.value.length
  return {
    'xl:grid-cols-1': qtd === 1,
    'xl:grid-cols-2': qtd === 2,
    'xl:grid-cols-3': qtd === 3,
    'xl:grid-cols-4': qtd === 4,
    'xl:grid-cols-5': qtd === 5,
    'xl:grid-cols-6': qtd >= 6
  }
})

onMounted(async () => {
  try {
    const response = await axios.get('/api/destaques/listardestaques')
    planosAtivos.value = response.data
      .filter(plano => plano.ativo)
      .sort((a, b) => a.ordem - b.ordem)
    console.log('Planos carregados:', planosAtivos.value.length)
  } catch (error) {
    console.error('Erro ao buscar planos:', error)
  } finally {
    carregando.value = false
  }
})
</script>
